import { getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
const pkgVersion = require('@/../package.json').version

@Module({ namespaced: true, name: 'configModule', store, dynamic: true })
export class ConfigModule extends VuexModule {
  public appName: string = 'WebEAI'
  public appCompany: string = 'Groupe SEB'
  public env: string | undefined = process.env.NODE_ENV
  public appVersion: string = pkgVersion
  public linkToConfluence :string = process.env.VUE_APP_CONFLUENCE + pkgVersion
  public maxFilter: number = Number.parseInt(process.env.VUE_APP_MAXFILTER as string, 10)
  public itemPerPageOptions: number[] = [50, 100, 500]
  public haveScroolXCache: boolean = false

  public get haveScroolX(): boolean{
    return this.haveScroolXCache
  }

  @Mutation
  public updateScroolX () {
    const elements = document.getElementsByClassName('main-container')
    if(elements && elements.length > 0){
      const container = elements[0] as Element
      const scrollWidth = container.scrollWidth ?? 0
      const clientWidth = container.clientWidth ?? 0
      this.haveScroolXCache =  scrollWidth > clientWidth
    }
  }
}

export default getModule(ConfigModule)
